import Cookies from 'js-cookie';
import * as Constants from './c7-api-constants';
import { request } from './request';

export const getTenantId = () => {
  if (window.stagingc7) {
    return Constants.TENANT_ID_STAGE;
  }
  return Constants.TENANT_ID_PROD;
};

export const publicHeader = () => ({
  Pragma: 'no-cache',
  tenant: getTenantId(),
});

export const nonPublicHeader = () => ({
  Authorization: Cookies.get(Constants.COOKIE_NAME_CUSTOMER_TOKEN),
  Pragma: 'no-cache',
  tenant: getTenantId(),
});

export const getV1RootUrl = () => `${Constants.BASE_URL}/v1`;
export const getV2RootUrl = () => `${Constants.BASE_URL}/v2`;

export const getCustomer = () =>
  request({
    url: `${getV1RootUrl()}/customer/self`,
    method: 'GET',
    headers: nonPublicHeader(),
    timeout: 1500,
  });

export const getClubSignup = (clubSignupId) =>
  request({
    url: `${getV1RootUrl()}/club-signup/${clubSignupId}`,
    method: 'GET',
    headers: publicHeader(),
    timeout: 1500,
  });

export const isCustomerSignedIn = (customerId) =>
  getCustomer()
    .then(({ id }) => id === customerId)
